import { render, staticRenderFns } from "./EcommerceFree.pug?vue&type=template&id=6a5022c7&lang=pug&external"
import script from "./EcommerceFree.js?vue&type=script&lang=js&external"
export * from "./EcommerceFree.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports